/**
 * D4F PRODUCT HERO - DELIVERY CALCULATOR & DYNAMIC FEATURES
 * - Berechnet Produktions- und Lieferzeiten dynamisch
 * - Zeigt dynamische Kundenanzahl basierend auf Bestellnummer
 * - Teeinblue Preview Button Handler
 */
(function () {
  const hero = document.querySelector('.d4f-product-hero');
  if (!hero) return;

  // Debug-Marker für Teeinblue
  if (hero.dataset.teeinblue === 'true') {
    console.debug('[D4F] Teeinblue product detected');
  }

  // Initialisierungen
  initDeliveryCalculator();
  initDynamicCustomerCount();
  initPreviewButton();

  /**
   * DELIVERY CALCULATOR
   */
  function initDeliveryCalculator() {
    const calculator = document.querySelector('.d4f-delivery-calc');
    if (!calculator) return;

    // Settings aus data-Attributen lesen
    const settings = {
      productionMin: parseInt(calculator.dataset.productionMin) || 2,
      productionMax: parseInt(calculator.dataset.productionMax) || 3,
      shippingMin: parseInt(calculator.dataset.shippingMin) || 1,
      shippingMax: parseInt(calculator.dataset.shippingMax) || 2,
      workDays: calculator.dataset.workDays || 'mo-fr',
      cutoffTime: parseInt(calculator.dataset.cutoffTime) || 14,
    };

    calculateAndDisplay(settings);
  }

  function calculateAndDisplay(settings) {
    const now = new Date();
    const currentHour = now.getHours();

    // Prüfen ob Bestellschluss überschritten
    let startDate = new Date(now);
    if (currentHour >= settings.cutoffTime) {
      startDate.setDate(startDate.getDate() + 1);
    }

    // Produktionsdatum berechnen
    const productionEndMin = addWorkingDays(
      new Date(startDate),
      settings.productionMin,
      settings.workDays
    );
    const productionEndMax = addWorkingDays(
      new Date(startDate),
      settings.productionMax,
      settings.workDays
    );

    // Lieferdatum berechnen
    const deliveryDateMin = addWorkingDays(
      new Date(productionEndMin),
      settings.shippingMin,
      settings.workDays
    );
    const deliveryDateMax = addWorkingDays(
      new Date(productionEndMax),
      settings.shippingMax,
      settings.workDays
    );

    // UI aktualisieren
    updateDeliveryUI(settings, productionEndMin, productionEndMax, deliveryDateMin, deliveryDateMax);
  }

  function addWorkingDays(startDate, days, workDays) {
    let date = new Date(startDate);
    let daysAdded = 0;

    while (daysAdded < days) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date, workDays)) {
        daysAdded++;
      }
    }

    return date;
  }

  function isWorkingDay(date, workDays) {
    const day = date.getDay(); // 0 = Sonntag, 6 = Samstag

    switch (workDays) {
      case 'mo-fr':
        return day >= 1 && day <= 5;
      case 'mo-sa':
        return day >= 1 && day <= 6;
      case 'mo-so':
        return true;
      default:
        return day >= 1 && day <= 5;
    }
  }

  function updateDeliveryUI(settings, prodMin, prodMax, delMin, delMax) {
    // Produktionszeit
    const productionValue = document.querySelector('.d4f-delivery-calc__step--production .d4f-delivery-calc__step-value');
    if (productionValue) {
      productionValue.textContent = `${settings.productionMin}-${settings.productionMax} Werktage`;
    }

    // Versandzeit
    const shippingValue = document.querySelector('.d4f-delivery-calc__step--shipping .d4f-delivery-calc__step-value');
    if (shippingValue) {
      shippingValue.textContent = `${settings.shippingMin}-${settings.shippingMax} Werktage`;
    }

    // Lieferdatum
    const resultDate = document.querySelector('.d4f-delivery-calc__result-date');
    if (resultDate) {
      const dateRange = formatDateRange(delMin, delMax);
      resultDate.textContent = dateRange;
    }
  }

  function formatDateRange(dateMin, dateMax) {
    const locale = document.documentElement.lang || 'de-DE';

    // Wenn gleicher Monat, nur einmal Monat anzeigen
    if (dateMin.getMonth() === dateMax.getMonth() && dateMin.getFullYear() === dateMax.getFullYear()) {
      const dayMin = dateMin.getDate();
      const dayMax = dateMax.getDate();
      const month = dateMin.toLocaleDateString(locale, { month: 'long' });
      const year = dateMin.getFullYear();
      return `${dayMin}. - ${dayMax}. ${month} ${year}`;
    }

    // Verschiedene Monate
    const minStr = dateMin.toLocaleDateString(locale, { day: '2-digit', month: 'short' });
    const maxStr = dateMax.toLocaleDateString(locale, { day: '2-digit', month: 'short', year: 'numeric' });
    return `${minStr} - ${maxStr}`;
  }

  /**
   * DYNAMISCHE KUNDENANZAHL
   * Zeigt die aktuelle Bestellnummer als Kundenanzahl
   */
  function initDynamicCustomerCount() {
    const trustBadge = document.querySelector('.d4f-trust-badge__count');
    if (!trustBadge) return;

    const fallbackCount = parseInt(trustBadge.dataset.fallback) || 6002;

    // Versuche die Bestellnummer aus verschiedenen Quellen zu laden
    fetchOrderCount()
      .then(count => {
        if (count && count > 0) {
          updateCustomerCount(count);
        } else {
          updateCustomerCount(fallbackCount);
        }
      })
      .catch(() => {
        updateCustomerCount(fallbackCount);
      });
  }

  async function fetchOrderCount() {
    try {
      // Option 1: Aus Shop Metafield (wenn gesetzt)
      const metafieldCount = document.querySelector('[data-shop-order-count]');
      if (metafieldCount) {
        return parseInt(metafieldCount.dataset.shopOrderCount);
      }

      // Option 2: Aus letzter Order im Theme (wenn verfügbar)
      if (window.Shopify && window.Shopify.shop) {
        // Hier könnten wir eine Ajax-Anfrage machen, aber das ist limitiert
        // Besser: Metafield nutzen
      }

      // Option 3: Fallback
      return null;
    } catch (error) {
      console.debug('[D4F] Could not fetch order count:', error);
      return null;
    }
  }

  function updateCustomerCount(count) {
    const countElement = document.querySelector('.d4f-trust-badge__count');
    if (!countElement) return;

    // Formatiere Zahl mit Tausendertrennzeichen
    const formattedCount = count.toLocaleString('de-DE');
    countElement.textContent = formattedCount;
  }

  /**
   * TEEINBLUE PREVIEW BUTTON
   * Öffnet die Teeinblue Vorschau durch Klick auf den originalen Button
   */
  function initPreviewButton() {
    const previewBtn = document.querySelector('.d4f-preview-btn');
    
    if (!previewBtn) {
      console.warn('[D4F Preview] Button not found in DOM');
      return;
    }

    console.log('[D4F Preview] Button found, attaching click handler');
    console.log('[D4F Preview] Product tags:', previewBtn.dataset.productTags);

    previewBtn.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('[D4F Preview] Button clicked!');
      openTeeinbluePreview();
    });
  }

  function openTeeinbluePreview() {
    console.log('[D4F Preview] Searching for Teeinblue preview button...');
    
    // Alle Buttons im DOM finden
    const allButtons = document.querySelectorAll('button');
    console.log('[D4F Preview] Total buttons found:', allButtons.length);
    
    // Suche nach dem originalen Teeinblue Preview Button
    const teeinbluePreviewBtn = document.querySelector('.tee-btn--preview');
    
    if (teeinbluePreviewBtn) {
      console.log('[D4F Preview] ✅ Teeinblue preview button found:', teeinbluePreviewBtn);
      console.log('[D4F Preview] Button classes:', teeinbluePreviewBtn.className);
      console.log('[D4F Preview] Button text:', teeinbluePreviewBtn.textContent);
      teeinbluePreviewBtn.click();
      return;
    }

    // Fallback: Alternative Selektoren
    const fallbackSelectors = [
      'button.tee-btn--preview',
      '.tee-btn.tee-btn--preview',
      'button[class*="preview"]',
      'button.tee-btn.tee-btn--full.tee-btn--preview',
      '[data-teeinblue-preview]',
      '.teeinblue-preview-btn'
    ];

    console.log('[D4F Preview] Trying fallback selectors...');
    
    for (const selector of fallbackSelectors) {
      const btn = document.querySelector(selector);
      if (btn) {
        console.log('[D4F Preview] ✅ Found via fallback:', selector, btn);
        btn.click();
        return;
      }
    }

    // Debug: Zeige alle Button-Klassen
    console.log('[D4F Preview] ❌ No preview button found. Available buttons:');
    allButtons.forEach((btn, index) => {
      console.log(`  ${index}: ${btn.className} - "${btn.textContent.trim().substring(0, 30)}"`);
    });

    // Suche nach Buttons die "vorschau" im Text haben
    const previewBtnByText = Array.from(allButtons).find(btn => 
      btn.textContent.toLowerCase().includes('vorschau')
    );

    if (previewBtnByText) {
      console.log('[D4F Preview] ✅ Found button with "Vorschau" text:', previewBtnByText);
      previewBtnByText.click();
      return;
    }
    
    alert('Vorschau-Funktion nicht verfügbar. Bitte stelle sicher, dass das Produkt personalisiert wurde.');
  }

  // Optional: Live-Update bei Änderung der Uhrzeit
  setInterval(() => {
    initDeliveryCalculator();
  }, 60000); // Jede Minute prüfen
})();